/**
 * loginMaintenanceCheck.js – Automatischer Maintenance-Hinweis auf Login-Seite
 *
 * Wird NUR auf der Login-Seite geladen (nicht eingeloggte Benutzer).
 * Pollt periodisch die .maintenance-Datei und entfernt den Wartungshinweis
 * asynchron, sobald das Deployment abgeschlossen ist.
 *
 * Features:
 * - Pollt alle 10 Sekunden /?maintenance_status (API-Endpunkt)
 * - Wenn Maintenance vorbei: Notice ausblenden, Button aktivieren, Erfolgsmeldung
 * - Verhindert Mehrfach-Ausführung nach einmaligem Entfernen
 */
(function() {
    'use strict';

    const POLL_INTERVAL_MS = 30000; // Alle 30 Sekunden prüfen (reicht für Maintenance-Ende-Erkennung)
    const STATUS_URL = '/?maintenance_status=1';
    var maintenanceResolved = false;
    var pollInterval = null;

    /**
     * Führt einen Hard-Refresh der Seite durch, der ALLE Browser-Caches
     * umgeht (HTTP-Disk-Cache, Memory-Cache, Service-Worker-Cache).
     *
     * caches.delete() löscht NUR Service-Worker-Caches. Der HTTP-Cache
     * wird durch .htaccess Expires-Header gesteuert und kann nur durch
     * location.reload(true) umgangen werden.
     */
    function hardReloadPage() {
        // Mit Zeitstempel zur Login-Seite navigieren, um Cache zu umgehen
        window.location.href = window.location.pathname + window.location.search + '&_=' + Date.now();
    }

    /**
     * Entfernt die Maintenance-Notice und aktiviert den Login-Button
     * Nach der Wartung wird ein Hard-Refresh durchgeführt, um alle Browser-Caches
     * zu umgehen (HTTP-Disk-Cache, Memory-Cache), sodass die neuesten Assets geladen werden.
     */
    function removeMaintenanceNotice() {
        if (maintenanceResolved) return;
        maintenanceResolved = true;

        // Polling stoppen
        if (pollInterval) {
            clearInterval(pollInterval);
            pollInterval = null;
        }

        // Optisches Feedback: Notice ausblenden, Button aktivieren
        var notice = document.querySelector('.maintenance-notice');
        var loginBtn = document.querySelector('button[name="submit_login"]');

        if (notice) {
            notice.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
            notice.style.opacity = '0';
            notice.style.transform = 'translateY(-20px)';
            setTimeout(function() {
                notice.style.display = 'none';
            }, 800);
        }

        if (loginBtn) {
            loginBtn.disabled = false;
            loginBtn.style.opacity = '1';
            loginBtn.style.cursor = 'pointer';
        }

        // Erfolgsmeldung anzeigen
        showSuccessMessage();

        // Hard-Refresh: Seite komplett neu laden, damit alle Assets frisch sind
        // Verzögert, damit der User die Erfolgsmeldung kurz sieht
        setTimeout(function() {
            hardReloadPage();
        }, 1200);
    }

    /**
     * Zeigt eine grüne Erfolgsmeldung an, dass die Wartung vorbei ist
     */
    function showSuccessMessage() {
        var formCard = document.querySelector('.form-card');
        if (!formCard) return;

        var successDiv = document.createElement('div');
        successDiv.id = 'maintenance-resolved-msg';
        successDiv.style.cssText =
            'background:rgba(0,200,100,0.15);' +
            'border:1px solid #00cc66;' +
            'border-radius:8px;' +
            'padding:20px;' +
            'margin-bottom:20px;' +
            'text-align:center;' +
            'animation: maintenanceResolvedFadeIn 0.6s ease-out;';

        successDiv.innerHTML =
            '<div style="font-size:48px;margin-bottom:10px;">' +
                '<i class="fas fa-check-circle" style="color:#00cc66;"></i>' +
            '</div>' +
            '<h3 style="color:#00cc66;margin:0 0 8px 0;">' +
                '<i class="fas fa-check-circle"></i> Wartung abgeschlossen' +
            '</h3>' +
            '<p style="color:#b8e6d0;margin:0;line-height:1.6;">' +
                'Die Aktualisierung wurde erfolgreich abgeschlossen.<br>' +
                'Du kannst dich jetzt wieder einloggen.' +
            '</p>';

        // Direkt nach der ggf. vorhandenen maintenance-notice einfügen
        var refNotice = document.querySelector('.maintenance-notice');
        if (refNotice && refNotice.parentNode) {
            refNotice.parentNode.insertBefore(successDiv, refNotice.nextSibling);
        } else {
            // Keine Notice vorhanden – am Anfang der FormCard einfügen
            var form = formCard.querySelector('form');
            if (form) {
                formCard.insertBefore(successDiv, form);
            } else {
                formCard.insertBefore(successDiv, formCard.firstChild);
            }
        }

        // Keyframe für Einblendung (einmalig ins CSS einfügen)
        if (!document.getElementById('maint-resolved-styles')) {
            var style = document.createElement('style');
            style.id = 'maint-resolved-styles';
            style.textContent =
                '@keyframes maintenanceResolvedFadeIn {' +
                    'from { opacity: 0; transform: translateY(-15px); }' +
                    'to { opacity: 1; transform: translateY(0); }' +
                '}';
            document.head.appendChild(style);
        }
    }

    /**
     * Prüft, ob die Wartung noch aktiv ist
     */
    function checkMaintenanceStatus() {
        if (maintenanceResolved) return;

        fetch(STATUS_URL, {
            method: 'GET',
            cache: 'no-store'
        })
        .then(function(resp) {
            return resp.json();
        })
        .then(function(data) {
            // Wenn maintenance false ist → Wartung vorbei
            if (data && data.maintenance === false) {
                removeMaintenanceNotice();
            }
        })
        .catch(function() {
            // Netzwerkfehler ignorieren – beim nächsten Poll erneut versuchen
        });
    }

    /**
     * Initialisierung
     */
    function init() {
        // Nur auf der Login-Seite mit maintenance=1 ausführen
        if (window.location.search.indexOf('maintenance=1') === -1) {
            return;
        }

        // Prüfen, ob überhaupt eine Maintenance-Notice sichtbar ist
        var notice = document.querySelector('.maintenance-notice');
        if (!notice) {
            // Keine Notice → keine aktive Wartung (mehr)
            return;
        }

        // Direkt prüfen und dann periodisch
        checkMaintenanceStatus();
        pollInterval = setInterval(checkMaintenanceStatus, POLL_INTERVAL_MS);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
